// Minimal, safe content renderer for blog posts.
// Supports: ## / ### headings, - bullet lists, blank-line paragraphs.
export default function PostBody({ content }) {
  const blocks = (content || "").split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className="space-y-6">
      {blocks.map((block, i) => {
        if (block.startsWith("### ")) {
          return (
            <h3 key={i} className="font-serif text-2xl md:text-3xl font-light mt-4">
              {block.replace(/^###\s+/, "")}
            </h3>
          );
        }
        if (block.startsWith("## ")) {
          return (
            <h2 key={i} className="font-serif text-3xl md:text-4xl font-light mt-6">
              {block.replace(/^##\s+/, "")}
            </h2>
          );
        }
        const lines = block.split("\n");
        if (lines.every((l) => l.trim().startsWith("- "))) {
          return (
            <ul key={i} className="space-y-2 pl-1">
              {lines.map((l, j) => (
                <li key={j} className="flex gap-3 text-lg leading-relaxed text-foreground/85">
                  <span className="text-primary mt-1">•</span>
                  {l.replace(/^-\s+/, "")}
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} className="text-lg leading-relaxed text-foreground/85">
            {block}
          </p>
        );
      })}
    </div>
  );
}
